import { reservationFormSchema } from '../../schema/reservationForm.schema';

import type {
  ReservationFormMainContext,
  ReservationFormMainEvent,
} from '../reservationFormMain.types';

export function canSubmitFromSubmitEvent({
  context,
  event,
}: {
  context: ReservationFormMainContext;
  event: ReservationFormMainEvent;
}): boolean {
  if (event.type !== 'SUBMIT' && event.type !== 'SAVE_AS_DRAFT') {
    return false;
  }
  if (!context.clientBC?.trim() || !context.passengerUUID?.trim()) {
    return false;
  }
  const parsed = reservationFormSchema.safeParse(event.formValues);
  return parsed.success;
}
